import React from "react"
import { Link } from "gatsby"

const LinksArray = () => {
  const linksArray = [
    {
      path: "/",
      name: "home",
    },
    {
      path: "/recipes",
      name: "recipes",
    },
    {
      path: "/tags",
      name: "tags",
    },
    {
      path: "/about",
      name: "about",
    },
    {
      path: "/contact",
      name: "contact",
    },
  ].map(link => {
    return link.path !== "/contact" ? (
      <Link
        className="nav-link"
        key={link.path}
        to={link.path}
        activeClassName="active-link"
      >
        {link.name}
      </Link>
    ) : (
      <div key={link.path} className="nav-link contact-link">
        <Link to={link.path} className="btn">
          {link.name}
        </Link>
      </div>
    )
  })

  return linksArray
}

export default LinksArray
